// extracted by mini-css-extract-plugin
module.exports = {"BookATattoo__heading":"styles-module--BookATattoo__heading--90ypE","BookATattoo__description":"styles-module--BookATattoo__description--392nz"};